import React from 'react';
import { styled } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import theme, { Theme } from 'theme';
import SidebarNav from './SidebarNav';

const PREFIX = 'Sidebar';

const classes = {
    sidebar: `${PREFIX}-sidebar`,
    sidebarHeader: `${PREFIX}-sidebarHeader`,
    sidebarTitleLink: `${PREFIX}-sidebarTitleLink`,
    logo: `${PREFIX}-logo`,
    title: `${PREFIX}-title`,
    name: `${PREFIX}-name`,
    tagline: `${PREFIX}-tagline`
};

const Root = styled('aside')((
    {
        theme: Theme
    }
) => ({
    [`&.${classes.sidebar}`]: {
		position: 'absolute',
		top: 0,
		bottom: 0,
		width: '100%',
		height: '100%',
		color: '#ffff',
		background: '#393937',
		overflowX: 'hidden',
		overflowY: 'auto',
	},

    [`& .${classes.sidebarHeader}`]: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		whiteSpace: 'nowrap',
		padding: '0 8px',
		...theme.mixins.toolbar,
	},

    [`& .${classes.sidebarTitleLink}`]: {
		textDecoration: 'none',
		color: 'inherit',
		display: 'flex',
		// '&:hover': {
		//   '& $logo': {
		//     color: '#274C65',
		//   },
		// },
	},

    [`& .${classes.logo}`]: {
		color: theme.palette.primary.main,
	},

    [`& .${classes.title}`]: (props: SidebarProps) => ({
		// fontSize: '20px',
		// fontWeight: 400,
		position: 'relative',
		overflow: 'visible',
		marginLeft: '5px',
		display: props.isDesktop && props.isSidebarCollapsedDesktop ? 'none' : 'block',
	}),

    [`& .${classes.name}`]: {},

    [`& .${classes.tagline}`]: {
		fontSize: 8,
		fontWeight: 'bold',
		position: 'absolute',
		top: '100%',
		marginTop: -5,
		background: theme.palette.primary.main,
		color: '#fff',
		borderRadius: 2,
		padding: '1px 3px',
		right: 0,
	}
}));

interface SidebarProps {
	onToggleClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	isDesktop: boolean;
	isMobile: boolean;
	isSidebarCollapsedDesktop: boolean;
	isSidebarOpenMobile: boolean;
}

const Sidebar = (props: SidebarProps) => {
	const { isDesktop, isSidebarCollapsedDesktop } = props;



	return (
        <Root className={classes.sidebar}>
			{/* <div className={classes.sidebarHeader}></div> */}
			<SidebarNav isCollapsed={isDesktop && isSidebarCollapsedDesktop} />
		</Root>
    );
};

export default Sidebar;
